
if (!devtricker_getTheLoggedUserId()) {
    let offcanvas = document.getElementById("offcanvasAccount");
    if (offcanvas) {
        offcanvas.classList.remove("d-none");
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".postage-navigation");
    const activeItem = container?.querySelector(".active:not(.no-scroll-focus *)");

    if (container && activeItem) {
      activeItem.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }
  });